<template>
    <div>
        <div class="card mt-3">
            <div class="card-header select-store">
                <h2 class="text-white d-inline">فروشگاه های شما</h2>
                <button class="btn btn-secondary float-left" data-toggle="modal" data-target="#company">افزودن فروشگاه
                </button>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 text-center" v-if="companies.length < 1">
                        <h2 class="no-item-alert">فروشگاهی ثبت نشده است</h2>
                        <button class="btn btn-primary" data-toggle="modal" data-target="#company">افزودن فروشگاه
                        </button>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 mb-3" v-for="(item, index) in companies">
                        <div class="card store text-center">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12 p-3" @click="onCardClicked(index)">
                                        <div>

                                            <h3 class="m-0">{{item.companyName}}</h3>
                                            <img class="view-image-print" :src="item.logoAddress !==null ? baseURL + item.logoAddress : 'https://panel.dbaccount.ir/img/buy.png'"/>
                                        </div>
                                        <span>نقش شما: </span>
                                        <span><b>{{item.postName}}</b></span>
                                        <hr v-if="item.users != null && item.users !== undefined"/>
                                        <span v-if="item.users != null && item.users !== undefined"> سایر کاربران: </span>
                                        <p v-if="item.users != null && item.users !== undefined" class="m-0"
                                           v-for="(it, ind) in item.users">
                                            {{it.personName +" "+ it.personBigName + " | " + it.postName }}
                                        </p>

                                    </div>
                                    <div :class="{addUser: item.postName === 'مدیر'}"
                                         class="col-3 p-0 d-flex align-items-center justify-content-center"
                                         @click="onUserModalClicked(index)">
                                        <i v-if="item.postName === 'مدیر'" class="fa fa-plus"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="sk-circle" id="loading">
                        <div class="sk-circle1 sk-child"></div>
                        <div class="sk-circle2 sk-child"></div>
                        <div class="sk-circle3 sk-child"></div>
                        <div class="sk-circle4 sk-child"></div>
                        <div class="sk-circle5 sk-child"></div>
                        <div class="sk-circle6 sk-child"></div>
                        <div class="sk-circle7 sk-child"></div>
                        <div class="sk-circle8 sk-child"></div>
                        <div class="sk-circle9 sk-child"></div>
                        <div class="sk-circle10 sk-child"></div>
                        <div class="sk-circle11 sk-child"></div>
                        <div class="sk-circle12 sk-child"></div>
                    </div>
                </div>
                <div class="modal fade" id="company" tabindex="-1" role="dialog" aria-labelledby="companyTitle"
                     aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-warning-grad glow-warning">
                                <h5 class="modal-title text-white" id="companyTitle">ایجاد فروشگاه جدید</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-lg-6 offset-lg-3 m-2">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">نام فروشگاه</span>
                                            </div>
                                            <input class="form-control" v-model="company.companyModel.companyName"/>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-12 d-inline-block m-2">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">نوع فروشگاه :</span>
                                            </div>
                                            <vs-select :data="availableCompanies" :mode="'create'"
                                                       :header="{multiple: false, label: 'newName'}"
                                                       @onChange="onChange"></vs-select>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 offset-lg-3 m-2" v-if="storeSelected">
                                        <span>{{storeDescription}} </span>
                                        <hr/>
                                        <span class="btn-danger">توجه : لطفا بعد از خرید در ساعات اداری با شماره 02632761127 و در ساعات غیر اداری با شماره 09222760495 جهت راه اندازی و آموزش تماس بگیرید.</span>
                                    </div>
                                    <div class="col-lg-6 offset-lg-3 m-2">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">کد معرف</span>
                                            </div>
                                            <input class="form-control" v-model="company.presenterCode"/>

                                        </div>
                                        <p class="btn-danger  d-block">لطفا کد معرف را وارد کنید(به عنوان
                                            مثال:C9851331)</p>
                                    </div>

                                </div>
                            </div>
                            <div class="modal-footer d-block">
                                <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                                <button type="button" class="btn btn-success m-0" @click="onModalOk">ثبت و پرداخت
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="user" tabindex="-1" role="dialog" aria-labelledby="userTitle"
                     aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-success-grad glow-success">
                                <h5 class="modal-title text-white" id="userTitle">افزودن کاربر جدید به
                                    {{user.companyName}}</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">شماره موبایل</span>
                                            </div>
                                            <input class="form-control" type="number" v-model="user.phoneNumber"/>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">نقش</span>
                                            </div>
                                            <vs-select :data="roles" :mode="'create'"
                                                       :header="{multiple: false, label: 'name'}"
                                                       @onChange="onRoleChange"></vs-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer d-block">
                                <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                                <button type="button" class="btn btn-success m-0" @click="onUserModalOk">ثبت</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '../_framework/event-bus.js';
    import * as $ from "jquery";
    import axios from "axios";
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from "../_framework/VsSelect";
    import Constants from "../Constants";

    export default {
        name: 'profile',
        components: {VsSelect},
        data() {
            return {
                companies: [],
                queryParams: {
                    pageSize: 8,
                    pageIndex: 0,
                    name: "",
                },
                company: {
                    companyCode: 0,

                    mobileNo: "",
                    price: 0,
                    description: "",
                    companyType: 0,
                    paymentType: 1300,
                    presenterCode: "",
                    uniqCode: "store",
                    companyModel: {
                        companyName: "",
                        postName: "1300",
                        postCount: 0,
                        serverLink: ""
                    }
                },
                user: {
                    companyId: 0,
                    phoneNumber: "",
                    post: 1100
                },
                roles: [
                    {
                        id: 1100,
                        name: "صندوق دار"
                    },
                    {
                        id: 1200,
                        name: "مدیریت"
                    },
                    {
                        id: 1300,
                        name: "تامین کننده"
                    },
                    {
                        id: 1400,
                        name: "فروشنده"
                    }
                ],
                availableCompanies: [],
                storeSelected: false,
                exiting: false,
                storeDescription: "",
                baseURL: ""
            }
        },
        mounted() {
            this.baseURL = Constants.AUTH_BASE_URL;
            // this.producerMobile = localStorage.getItem("phoneNumber");
            axios.defaults.baseURL = Constants.AUTH_API_BASE_URL;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem("token_mobile");
            axios.get('persons/0').then(response => {
                localStorage.setItem("phoneNumber", response.data.phoneNumber);
            });
            axios.get('company', {params: this.queryParams}).then(response => {
                let cops = response.data;
                for (let item of cops) {
                    if (item.postName === "مدیر") {
                        axios.get(`Company/GetPersonForCompany/?companyId=${item.id}`).then(resp => {
                            item.users = [];
                            for (let u of resp.data) {
                                if (u.phoneNumber === localStorage.getItem("phoneNumber")) {

                                } else {
                                    item.users.push(u);
                                }
                            }
                            this.companies.push(item);
                        }).catch(error => {
                            this.companies.push(item);
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    } else {
                        this.companies.push(item);
                    }
                }
                $("#loading").hide();
            }).catch(error => {
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });
            axios.get('company/GetAvailableCompanies', {params: this.queryParams}).then(response => {
                this.availableCompanies = response.data;
                for (var item of this.availableCompanies) {
                    // item.newName = item.name + " (" + item.description + ") قیمت " + item.price + " تومان";
                    item.newName = item.name + " قیمت " + item.price + " تومان";
                    // item.nPrice = item.
                }
                // console.log(this.availableCompanies)
                // $("#loading").hide();
            }).catch(error => {
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });


        },
        methods: {
            onModalOk() {
                if (this.company.companyModel.companyName == null || this.company.companyModel.companyName === "") {
                    Utils.handleErrorWithNotification("لطفا نام فروشگاه را وارد کنید", this.$noty);
                } else if (this.company.companyType === 0) {
                    Utils.handleErrorWithNotification("لطفا یک مدل نرم افزار حسابداری فروشگاهی را انتخاب کنید", this.$noty);

                } else if (this.company.presenterCode === "" || this.company.presenterCode === null) {
                    // if (confirm("کد معرف خود را وارد کنید و 10 درصد تخفیف بگیرید")) {
                    //     Utils.handleErrorWithNotification("لطفا کد معرف را وارد کنید", this.$noty);
                    // } else {
                        axios.post('company/CreateToPay', this.company).then(response => {
                            $("#company").modal('hide');
                            window.location.href = response.data.link;
                            // this.$noty.success('فروشگاه با موفقیت افزوده شد!');
                            // Utils.resetObject(this.company);
                            // this.company.companyCode = 0;
                            // axios.get('company', {params: this.queryParams}).then(response => {
                            //     this.companies = response.data;
                            //     $("#loading").hide();
                            // }).catch(error => {
                            //     Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            // });
                        }).catch(error => {
                            Utils.handleErrorWithNotification(error.response.messages, this.$noty);
                        });
                    // }
                } else {
                    axios.post('company/CreateToPay', this.company).then(response => {
                        $("#company").modal('hide');
                        window.location.href = response.data.link;
                        // this.$noty.success('فروشگاه با موفقیت افزوده شد!');
                        // Utils.resetObject(this.company);
                        // this.company.companyCode = 0;
                        // axios.get('company', {params: this.queryParams}).then(response => {
                        //     this.companies = response.data;
                        //     $("#loading").hide();
                        // }).catch(error => {
                        //     Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        // });
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.messages, this.$noty);
                    });
                }
            },
            onChange(val) {
                this.company.companyType = val.type;
                // this.company.price = val.price;
                this.company.description = val.description;
                this.storeSelected = true;
                this.storeDescription = "توضیحات تکمیلی : " + val.name + " (" + val.description + ") قیمت " + val.price + " تومان";

            },
            onCardClicked(index) {
                $("#loading").show();
                if (this.companies[index].companyType === 1) {
                    let target = '_blank';
                    window.open('https://soft.badian-co.ir/', target);
                    this.$noty.success("این فروشگاه فقط بر روی موبایل قابل دسترس است");
                } else {
                    let model = {
                        companyId: 0,
                    };
                    axios.defaults.baseURL =Constants.AUTH_API_BASE_URL;
                    // axios.get(`Company/GetPersonForCompany/?companyId=${this.companies[index].id}`).then(resp => {
                    axios.get(`Company/GetUserPostInCompany/?companyId=${this.companies[index].id}`).then(resp => {
                        let companydata = resp.data;
                        axios.get(`Company/GetPersonForCompany/?companyId=${this.companies[index].id}`).then(resp => {
                            let company_usersId = [];
                            let company_usersName = [];
                            for (let u of resp.data) {
                                company_usersId.push(u.id);
                                company_usersName.push(u.personName + " " + u.personBigName)
                            }
                            localStorage.setItem("company_usersId", JSON.stringify(company_usersId));
                            localStorage.setItem("company_usersName", JSON.stringify(company_usersName));
                        });
                        localStorage.setItem("companyPostName", companydata[0].postName);

                        window.API_BASE_URL = this.companies[index].serverLink + "/api";
                        window.BASE_URL = this.companies[index].serverLink;
                        localStorage.setItem("API_BASE_URL", window.API_BASE_URL);
                        localStorage.setItem("BASE_URL", window.BASE_URL);
                        localStorage.setItem("logoAddress", this.baseURL + this.companies[index].logoAddress);
                        localStorage.setItem("codeEghtesadi", this.companies[index].codeEghtesadi);
                        localStorage.setItem("codeMelli", this.companies[index].codeMelli);
                        localStorage.setItem("companymobile", this.companies[index].mobile);
                        localStorage.setItem("companyphone", this.companies[index].phone);
                        localStorage.setItem("companyaddress", this.companies[index].address);
                        localStorage.setItem("companyId", this.companies[index].id);
                        localStorage.setItem("companyType", this.companies[index].companyType);
                        axios.defaults.baseURL = Constants.API_BASE_URL;
                        model.companyId = this.companies[index].id;
                        EventBus.$emit('logOut', false);
                        axios.post('auth', model).then(response => {
                            localStorage.setItem("companyName", this.companies[index].companyName);
                            EventBus.$emit('companyNameChange', this.companies[index].companyName);
                            this.$noty.success(`با موفقیت وارد ${this.companies[index].companyName} شدید!`);
                            localStorage.setItem("auth_token", response.data);
                            this.$router.push({name: 'home'});
                            $("#loading").hide();
                        })
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        this.loading = false;
                    });
                }
            },
            onRoleChange(val) {
                this.user.post = val.id;
            },
            onUserModalClicked(index) {
                if (this.companies[index].postName === 'مدیر') {
                    $("#user").modal('show');
                    this.user.companyId = this.companies[index].id;
                } else {
                    this.onCardClicked(index);
                }
            },
            onUserModalOk() {
                axios.put('company', this.user).then(response => {
                    this.$noty.success("کاربر با موفقیت به فروشگاه شما اضافه شد!");
                    Utils.resetObject(this.user);
                    this.user.companyId = 0;
                    this.user.post = 1100;
                    $("#user").modal('hide');
                }).catch(error => {
                    $("#user").modal('hide');
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            }
        },
        watch: {
            companies(val) {
            }

        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#company").hasClass("show")) {
                $("#company").modal("hide");
                next(false);
            } else {
                if ($("#user").hasClass("show")) {
                    $("#user").modal("hide");
                    next(false);
                } else {
                    if (this.exiting) {
                        next();
                    } else {
                        if (to.name === 'login') {
                            this.exiting = true;
                            if (confirm("آیا میخواهید خارج شوید؟")) {
                                localStorage.removeItem("phoneNumber");
                                localStorage.removeItem("token_mobile");
                                localStorage.removeItem("isRegistered");
                                localStorage.removeItem("auth_token");
                                localStorage.removeItem("userId");
                                localStorage.removeItem("companyId");
                                localStorage.removeItem("companyName");
                                EventBus.$emit('companyNameChange', "");
                                EventBus.$emit('logOut', true);
                                this.$router.push({
                                    name: 'login',
                                });
                            } else {
                                this.exiting = false;
                            }
                        } else {
                            next();
                        }
                    }
                }
            }


        },
    }
</script>

<style lang="scss" scoped>
    .card.store {
        box-shadow: 0 20px 10px -15px rgba(0, 0, 0, 0.80);
        border: none;
        border-radius: 0;
        border-right: 5px solid #00bfa5;
        border-top: 1px solid rgba(0, 0, 0, 0.25);
        border-left: 1px solid rgba(0, 0, 0, 0.25);
        border-bottom: 1px solid rgba(0, 0, 0, 0.25);
        transition: all 0.3s;
        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
    }

    .card.store:hover {
        cursor: pointer;
        /*transform: translateY(-5px);*/
        /*box-shadow: 0 27px 10px -17px rgba(0, 0, 0, 0.4);*/
    }

    .card-header button {
        background-color: #dddddd;
        color: black;
        border: none;
        font-family: Shabnam, sans-serif;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
    }
</style>